module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimSuccess"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../images/logo_za.png"),
      "alt": "众安保险"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "claim_success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "result"
  }, [_vm._v("索赔登记成功！")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "view"
  }, [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("查看索赔所需资料")]), _c('router-link', {
    attrs: {
      "to": "/ClaimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "bottom_bg"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tips"
  }, [_vm._v("请尽快用电脑登陆 "), _c('span', [_vm._v("https://insurance.lianwifi.com/pc/index.html")]), _vm._v(" ，下载填写交易补偿申请表，并准备相关索赔资料寄送指定地址，方便理赔。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bf7de2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimSuccess.vue
// module id = 829
// module chunks = 1